import { render, staticRenderFns } from "./AdditionalInfo.vue?vue&type=template&id=c58b8afa&scoped=true"
import script from "./AdditionalInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalInfo.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInfo.vue?vue&type=style&index=0&id=c58b8afa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58b8afa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c58b8afa')) {
      api.createRecord('c58b8afa', component.options)
    } else {
      api.reload('c58b8afa', component.options)
    }
    module.hot.accept("./AdditionalInfo.vue?vue&type=template&id=c58b8afa&scoped=true", function () {
      api.rerender('c58b8afa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/visitRegistry/components/AdditionalInfo.vue"
export default component.exports